import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-6 bg-surface overflow-hidden">
      {/* Large 404 bg text */}
      <h1 className="absolute text-[12rem] md:text-[18rem] font-black text-surfaceMuted select-none pointer-events-none z-0 leading-none">
        404
      </h1>

      <div className="relative z-10 animate-fade-in-up">
        <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mx-auto mb-5">
          <svg className="w-6 h-6 text-background" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h2 className="text-xl md:text-2xl font-bold text-primary mb-2">
          ページが見つかりません
        </h2>
        <p className="text-sm text-textMuted mb-1 font-mono bg-surface px-3 py-1 rounded-md inline-block border border-border">
          {location.pathname}
        </p>
        <p className="text-sm text-textMuted mt-4 mb-8 max-w-sm mx-auto">
          お探しのページは存在しないか、移動した可能性があります。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" className="app-btn-primary">トップページへ</Link>
          <Link to="/app" className="app-btn-secondary">ダッシュボードへ</Link>
        </div>
      </div>
    </div>
  );
}
